export default __webpack_public_path__ + "static/media/info-mine-block.8a5aff68.svg";